export default __webpack_public_path__ + "static/media/ng.32f4e270.ico";